import(/* webpackMode: "eager" */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/login/LoginForm.tsx");
